import React, { useState } from 'react'
import { Linking, Platform, Text } from 'react-native'

import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { styled } from 'nativewind'
import Animated, { FadeInUp } from 'react-native-reanimated'

import { Icon } from '../icons'
import { Stack, XStack, YStack } from '../layout'
import Pressable from '../pressable'
import { colors } from '../tailwind'
import { B5, B6, SH3 } from '../typography'
import { useContentLinks } from './useContentLinks'

const AccordianContainer = styled(
  Stack,
  'bg-neutral-white100 border border-grays-30 px-2 py-4/2 mb-2 rounded'
)
const Body = styled(XStack, 'px-4/2 py-2 mt-2 bg-grays-10 rounded-sm')

const AccordianLogoContainer = styled(XStack)
const TitleContainer = styled(Stack, 'ml-2')
const Title = styled(SH3, 'text-grays-100')
const Subtitle = styled(B6, ' text-grays-60')
const Content = styled(B5, ' text-grays-60')

const Link = ({ link }: { link?: string }) => {
  if (!link) {
    return null
  }

  const openLink = () => {
    Linking.openURL(link)
  }

  return (
    <Text className="text-primary-100 flex-1 flex-wrap" onPress={openLink}>
      {link}
    </Text>
  )
}

export function Accordian({
  title,
  subtitle,
  content: _content,
  iconType = 'QuestionMarkOutlined',
  eventName,
  eventPayload,
  contentComponent,
  isOpenInit = false,
  isIcon = true,
  brandId,
  ...props
}: any) {
  const [collapsed, setCollapsed] = useState(isOpenInit)

  //TODO: fix this - rich text with links
  const { content, link, link2 } = useContentLinks({
    _content,
    brandId,
    eventPayload,
  })

  return (
    <AccordianContainer {...props}>
      <Pressable
        onPress={() => setCollapsed(!collapsed)}
        eventName={eventName}
        eventPayload={eventPayload}
      >
        <AccordianLogoContainer>
          {isIcon && <Icon type={iconType} size={24} />}
          <TitleContainer className="flex-1">
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </TitleContainer>
          <Icon
            type={collapsed ? 'ArrowTop' : 'ArrowDown'}
            size={24}
            color={colors.primary[100]}
          />
        </AccordianLogoContainer>
      </Pressable>

      {collapsed && (
        <Animated.View entering={FadeInUp.duration(500)}>
          <Body>
            <YStack>
              {!!content && (
                <Content
                  style={Platform.OS === 'web' && { width: DEVICE_WIDTH - 70 }}
                >
                  {content}
                  <Link link={link} />
                  {link2 && (
                    <>
                      {'\n'}
                      <Link link={link2} />
                    </>
                  )}
                </Content>
              )}
              {contentComponent ?? null}
            </YStack>
          </Body>
        </Animated.View>
      )}
    </AccordianContainer>
  )
}
